const translation = {
  title: 'Odkryj',
  sidebar: {
    discovery: 'Odkrywanie',
    chat: 'Czat',
    workspace: 'Przestrzeń robocza',
    action: {
      pin: 'Przypnij',
      unpin: 'Odepnij',
      rename: 'Zmień nazwę',
      delete: 'Usuń',
    },
    delete: {
      title: 'Usuń aplikację',
      content: 'Czy na pewno chcesz usunąć tę aplikację?',
    },
  },
  apps: {
    title: 'Odkrywaj aplikacje stworzone przez Dify',
    description:
      'Wykorzystaj te aplikacje szablonowe natychmiast lub dostosuj własne aplikacje na podstawie szablonów.',
    allCategories: 'Polecane',
  },
  appCard: {
    addToWorkspace: 'Dodaj do przestrzeni roboczej',
    customize: 'Dostosuj',
  },
  appCustomize: {
    title: 'Utwórz aplikację z {{name}}',
    subTitle: 'Ikona i nazwa aplikacji',
    nameRequired: 'Nazwa aplikacji jest wymagana',
  },
  category: {
    Assistant: 'Asystent',
    Writing: 'Pisanie',
    Translate: 'Tłumaczenie',
    Programming: 'Programowanie',
    HR: 'HR',
    Agent: 'Agent',
    Workflow: 'Przepływ pracy',
    Entertainment: 'Rozrywka',
  },
}

export default translation
